import React, { useContext, useEffect, useState } from "react";
import { getChoresDiffrence, getDateHelper, getFrequencyDates, getFrequencyValue, getPriceHelper, isDateFinalized, setDateHelper, userDetails } from "../../utils/Helper";
import $ from 'jquery';
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import ReactSelect from "react-select";
import DatePicker from "react-datepicker";
import calLogo from '../../assets/images/calender.svg'
import Button from "../../components/ui/Button";
import { useForm } from "react-hook-form";
import moment from 'moment';
import { FREQUENCY_TYPES, HOUSEHOLD_TYPES } from "../../constants/Constants";
import { ErrorMessage } from "@hookform/error-message";
import { motion, AnimatePresence } from 'framer-motion';
import toast from "react-hot-toast";
import { yupResolver } from "@hookform/resolvers/yup";
import ValidationMessage from "../../constants/ValidationMessage";
import * as yup from 'yup';
import authContext from "../../context/authContext";
import Checkbox from "../../components/layouts/CheckBox";
import chevRight from '../../assets/images/chev-right.svg'
import ProfileImage from "../../components/layouts/ProfileImage";


interface expensesFilterInputs {
    date?: string;
    payer?: any;
    sharing_exp?: any;
    ec_id?: any;
    amount: string;
    new_date?: string
    description?: string
    s_between?: string[];
};

const EditAllExpences = ({ hhMembers, payers, expensesCategories, editExpense, onCancel, onSuccess, finalizedMonths }: any) => {

    console.log("editExpense: ", editExpense)
    let profile: any = useContext(authContext);
    profile = profile?.data;
    const updateExpense = useMakeRequest();
    const [isShareBetweenExpanded, setIsShareBetweenExpanded] = useState(false);

    const [editFields, setEditFields] = useState({
        date: true,
        amount: true,
        ec_id: true,
        payer: true,
        s_between: true,
        description: true,
    });

    // Dynamic validation schema based on checkbox states
    const getSchema = (checks: any) =>
        yup.object().shape({
            new_date: checks.date
                ? yup.string().required("Please select a date")
                : yup.string().nullable(),

            amount: checks.amount
                ? yup.string()
                    .required(ValidationMessage.Field("an amount"))
                    .test(
                        'amount-greater-than-zero',
                        ValidationMessage.Field("an amount more than 0"),
                        function (value: any) {
                            if (!value) return false;
                            const numValue = parseFloat(value);
                            return numValue > 0;
                        }
                    )
                : yup.string().nullable(),

            ec_id: checks.ec_id
                ? yup.object().nullable().required("Please enter an expense type.")
                : yup.object().nullable(),

            payer: checks.payer
                ? yup.object().nullable().required("Please enter a payer.")
                : yup.object().nullable(),

            s_between: checks.s_between
                ? yup.array()
                    .min(1, "Please select at least one member.")
                    .required("Please select members sharing this expense.")
                : yup.array().nullable(),

            description: checks.description
                ? yup.string().max(200, "Description must be less than 200 characters")
                : yup.string().nullable(),
        });

    const { register, watch, setValue, getValues, formState: { errors }, handleSubmit, trigger, reset } = useForm<expensesFilterInputs>({
        mode: 'onChange',
        resolver: yupResolver(getSchema(editFields)) as any
    });

    // Reset form when modal opens
    useEffect(() => {
        const modal = document.getElementById("editAllExpencesModal");

        const handleOpen = () => {
            reset({
                date: "",
                amount: "",
                ec_id: null,
                payer: null,
                s_between: [],
                new_date: "",
                description: "",
            });

            setEditFields({
                date: true,
                amount: true,
                ec_id: true,
                payer: true,
                s_between: true,
                description: true,
            });
        };

        modal?.addEventListener("shown.bs.modal", handleOpen);

        return () => modal?.removeEventListener("shown.bs.modal", handleOpen);
    }, []);

    const toggleField = (field: keyof typeof editFields) => {
        setEditFields((prev) => {
            const newState = { ...prev, [field]: !prev[field] };
            return newState;
        });
    };

    const onSubmit = (payload: any) => {
        const is_finalized = isDateFinalized(payload?.new_date, finalizedMonths || []);
        if (is_finalized) {
            toast.error("Selected date already finalized.")
            return;
        }

        const updatedArray = editExpense.map((item: any) => {
            const updatedItem: any = {
                ...item,
                new_date: null,
                is_deleted: 0,
            };

            if (editFields.ec_id) {
                updatedItem.ec_id = payload?.ec_id?.value;
            }
            if (editFields.payer) {
                if (payload.payer?.value === "01") {
                    updatedItem.payer = "0"
                    updatedItem.is_joint_account = "1"
                } else if (payload.payer?.value === "0") {
                    updatedItem.payer = "0"
                    updatedItem.is_joint_account = "0"
                } else {
                    updatedItem.payer = payload.payer?.value
                    updatedItem.is_joint_account = "0"
                }
            }
            if (editFields.amount) {
                updatedItem.amount = payload?.amount;
            }
            if (editFields.date) {
                updatedItem.new_date =
                    payload?.date === payload?.new_date ? null : payload?.new_date;
            }
            if (editFields.description) {
                updatedItem.desc = payload?.description ?? '';
            }

            updatedItem.s_between =
                payload?.s_between && payload.s_between.length > 0
                    ? payload.s_between
                    : item?.shared_between?.map(
                        (user: any) => user?.split_user?.uuid
                    ) ?? [];

            return updatedItem;
        });

        console.log("updatedArray; ", updatedArray)

        updateExpense.makeRequest({
            url: ApiConstants?.AllExpenseUpdate,
            payload: updatedArray,
        });
    }

    useEffect(() => {
        if (updateExpense?.status) {
            onSuccess();
            reset();
            setEditFields({
                date: true,
                amount: true,
                ec_id: true,
                payer: true,
                s_between: true,
                description: true,
            });
            $('.btn-close-modal').click()
            setTimeout(() => {
                toast.success('Expenses updated successfully.');
            }, 500);
        }
    }, [updateExpense?.status])

    const handleSelectShareBetween = (value: any) => {
        let prevSelected: any = watch("s_between") || [];
        console.log("prevSelected: ", prevSelected)
        if (prevSelected.includes(value)) {
            prevSelected = prevSelected.filter((item: any) => item !== value);
        } else {
            prevSelected = [...prevSelected, value];
        }
        setValue("s_between", prevSelected);
        trigger("s_between");
    };

    return (
        <div className="modal fade bottom-sheet-modal" id="editAllExpencesModal" tabIndex={-1} aria-labelledby="editAllExpencesModalLabel" aria-hidden="true" data-bs-backdrop="true" data-bs-keyboard="true" >

            <div className="modal-dialog">
                <div className="modal-content">
                    {/* Bottom Sheet Handle */}
                    <div className="bottom-sheet-handle">
                        <div className="handle-bar"></div>
                    </div>

                    <div className="modal-header">
                        <h1 className="modal-title" id="editAllExpencesModal">Edit Expenses</h1>
                        <span className="modal-description">
                            If a box is checked, the field will be changed for all expenses selected. If a box is not checked, the field will not be changed.
                        </span>
                    </div>


                    <div className="modal-body">
                        <form className="row gy-3" onSubmit={handleSubmit(onSubmit)}>
                            <div className='col-6'>
                                <div className="com-input-grp">
                                    <Checkbox
                                        id={"edit_date"}
                                        labelText={"Edit Date"}
                                        checked={editFields.date}
                                        onChange={() => toggleField("date")}
                                    />
                                    {/* <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={editFields.date}
                                        onChange={() => toggleField("date")}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                    <label className="form-label">Edit Date</label> */}
                                    <DatePicker
                                        className='form-control'
                                        placeholderText="MM/DD/YYYY"
                                        timeFormat="MM DD YYYY"
                                        onKeyDown={(e: any) => e.preventDefault()}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={50}
                                        selected={watch('new_date') ? moment(watch('new_date')).toDate() : null}
                                        showIcon
                                        icon={<><img className="calIcon" src={calLogo} alt="" /></>}
                                        onChange={(start_date: any) => {
                                            setValue('new_date', setDateHelper({ date: start_date }))
                                            trigger('new_date')
                                        }}
                                        minDate={
                                            profile?.hh_member?.member_type == HOUSEHOLD_TYPES?.ADMIN ?
                                                moment(profile?.hh_member?.billing_date).toDate() :
                                                moment(profile?.hh_member?.created_at).toDate()
                                        }
                                    />
                                    <ErrorMessage
                                        errors={errors}
                                        name="new_date"
                                        render={({ message }) => <p className='valid-error'>{message}</p>}
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="com-input-grp">
                                    <Checkbox
                                        id={"edit_amount"}
                                        labelText={"Edit Amount"}
                                        checked={editFields.amount}
                                        onChange={() => toggleField("amount")}
                                    />
                                    {/* <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={editFields.amount}
                                        onChange={() => toggleField("amount")}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                    <label className="form-label">Edit Amount</label> */}
                                    <div className='custom-select'>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter amount"
                                            {...register('amount')}
                                            onInput={(e: any) => {
                                                let inputValue = e.target.value;
                                                inputValue = inputValue.replace(/[^0-9.]/g, '');
                                                const decimalCount = inputValue.split('.').length - 1;
                                                if (decimalCount > 1) {
                                                    const parts = inputValue.split('.');
                                                    inputValue = parts[0] + '.' + parts.slice(1).join('');
                                                }
                                                const parts = inputValue.split('.');
                                                if (parts[0].length > 7) {
                                                    parts[0] = parts[0].substring(0, 7);
                                                }
                                                if (parts.length > 1) {
                                                    parts[1] = parts[1]?.substring(0, 2);
                                                }
                                                inputValue = parts.join('.');
                                                e.target.value = inputValue;
                                            }}
                                        />
                                    </div>
                                    <ErrorMessage
                                        errors={errors}
                                        name="amount"
                                        render={({ message }) => <p className='valid-error'>{message}</p>}
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="com-input-grp">
                                    <Checkbox
                                        id={"edit_expense_type"}
                                        labelText={"Edit Expense Type"}
                                        checked={editFields.ec_id}
                                        onChange={() => toggleField("ec_id")}
                                    />
                                    {/* <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={editFields.ec_id}
                                        onChange={() => toggleField("ec_id")}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                    <label className="form-label">Edit Expense Type</label> */}
                                    <div className='custom-select'>
                                        <ReactSelect
                                            options={expensesCategories?.data?.data}
                                            value={watch('ec_id')}
                                            className="com-r-select"
                                            classNamePrefix="com-r-select"
                                            placeholder="Expense Type"
                                            isLoading={expensesCategories?.loading}
                                            onChange={(selectedOption: any) => {
                                                setValue("ec_id", selectedOption);
                                                trigger("ec_id");
                                            }}
                                        />
                                    </div>
                                    <ErrorMessage
                                        errors={errors}
                                        name="ec_id"
                                        render={({ message }) => <p className='valid-error'>{message}</p>}
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="com-input-grp">
                                    <Checkbox
                                        id={"edit_payer"}
                                        labelText={"Edit Payer"}
                                        checked={editFields.payer}
                                        onChange={() => toggleField("payer")}
                                    />
                                    {/* <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={editFields.payer}
                                        onChange={() => toggleField("payer")}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                    <label className="form-label">Edit Payer</label> */}
                                    <div className='custom-select'>
                                        <ReactSelect
                                            value={watch('payer')}
                                            options={[...payers]}
                                            className="com-r-select"
                                            classNamePrefix="com-r-select"
                                            placeholder="Paid by"
                                            onChange={(selectedOption: any) => {
                                                setValue("payer", selectedOption);
                                                trigger("payer");
                                                if (editExpense?.paid_by?.value !== "0" || editExpense?.paid_by?.value !== "01") {
                                                    const allMemb: any = [];
                                                    editExpense?.shared_between?.length > 0 &&
                                                        editExpense?.shared_between?.map((memb: any) => {
                                                            allMemb.push(memb?.split_user?.uuid);
                                                        });
                                                    setValue("s_between", allMemb);
                                                    trigger("s_between");
                                                }
                                            }}
                                        />
                                    </div>
                                    <ErrorMessage
                                        errors={errors}
                                        name="payer"
                                        render={({ message }) => <p className='valid-error'>{message}</p>}
                                    />
                                </div>
                            </div>
                            <div className="col-12">


                                <div className="com-input-grp">
                                    <Checkbox
                                        id={"edit_member_sharing"}
                                        labelText={"Edit Members Sharing This Expense"}
                                        checked={editFields.s_between}
                                        onChange={() => toggleField("s_between")}
                                    />
                                    <div className="custom-select share-between-container">
                                        <div className="share-between-header">
                                            <div
                                                className={`btn-link w-100 d-flex justify-content-between align-items-center p-3 ${isShareBetweenExpanded ? '' : 'collapsed'}`}
                                                onClick={() => setIsShareBetweenExpanded(!isShareBetweenExpanded)}
                                            >
                                                <span className="fw-normal">Members</span>
                                                <img src={chevRight} className="chevron-icon" />
                                            </div>
                                        </div>
                                        <div
                                            className={`share-between-collapse ${isShareBetweenExpanded ? 'show' : ''}`}
                                        >

                                            <div className="share-between-body">
                                                {hhMembers?.data?.data?.length > 0
                                                    ? hhMembers?.data?.data?.map(
                                                        (memb: any, membIndex: any) => {
                                                            return (
                                                                <div key={membIndex} className="share-member-item">
                                                                    <div className="d-flex align-items-center gap-3">
                                                                        {/* <img
                                                                            src={memb?.user?.profile_pic}
                                                                            alt={memb?.user?.name}
                                                                            className="member-avatar"
                                                                        /> */}
                                                                        <ProfileImage src={memb?.user?.profile_pic} size={20} />
                                                                        <span className="member-name">
                                                                            {profile?.uuid === memb?.user?.uuid
                                                                                ? `Me`
                                                                                : memb?.user?.name}
                                                                        </span>
                                                                    </div>
                                                                    <div className="form-check">
                                                                        <div className="form-check com-check check-green m-0">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                onClick={(e) => {
                                                                                    console.log("watch('payer'): ", watch('payer'))
                                                                                    console.log("editExpense?.paid_by: ", editExpense?.paid_by)
                                                                                    const payer = watch('payer') || editExpense[0]?.paid_by;
                                                                                    console.log("payer", payer)
                                                                                    if (!payer) {
                                                                                        e.preventDefault();
                                                                                        toast.error("Please select payer first.");
                                                                                        return;
                                                                                    }

                                                                                    handleSelectShareBetween(memb?.user?.uuid);
                                                                                }}
                                                                                checked={watch(
                                                                                    "s_between"
                                                                                )?.includes(memb?.user?.uuid)}
                                                                            />
                                                                        </div>
                                                                        {/* <Checkbox
                                                                            id={memb?.user?.uuid}
                                                                            name="s_between_dummy"
                                                                            onChange={(e) => {
                                                                                const payer = watch('payer');
                                                                                if (!payer) {
                                                                                    e.preventDefault();
                                                                                    toast.error("Please select payer first.");
                                                                                    return;
                                                                                }
                                                                                handleSelectShareBetween(memb?.user?.uuid)
                                                                            }}
                                                                            checked={watch("s_between")?.includes(
                                                                                memb?.user?.uuid
                                                                            )}
                                                                        /> */}
                                                                    </div>
                                                                </div>
                                                            );
                                                        }
                                                    )
                                                    : <div className="text-center py-3 text-muted">No members available</div>}
                                            </div>

                                        </div>
                                        <ErrorMessage
                                            errors={errors}
                                            name="s_between"
                                            render={({ message }) => (
                                                <p className="valid-error">{message}</p>
                                            )}
                                        />
                                    </div>
                                </div>

                                {/* <div className="custom-select">
                                        <div
                                            className="accordion expenses-accordian"
                                            id="choresAccordian"
                                        >
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#collapseOne"
                                                        aria-expanded="true"
                                                        aria-controls="collapseOne"
                                                    >
                                                        <span className="">Members</span>
                                                    </button>
                                                </h2>
                                                <div
                                                    id="collapseOne"
                                                    className="accordion-collapse collapse show"
                                                    data-bs-parent="#choresAccordian"
                                                >
                                                    <div className="accordion-body">
                                                        <div className="table-responsive">
                                                            <table className="table expenses-accordian-table m-0">
                                                                <tbody>
                                                                    {hhMembers?.data?.data?.length > 0
                                                                        ? hhMembers?.data?.data?.map(
                                                                            (memb: any, membINdex: any) => {
                                                                                return (
                                                                                    <tr key={membINdex}>
                                                                                        <td style={{ width: "55px" }}>
                                                                                            <div className="form-check com-check check-green m-0">
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    className="form-check-input"
                                                                                                    onClick={(e) => {
                                                                                                        const payer = watch('payer');
                                                                                                        if (!payer) {
                                                                                                            e.preventDefault();
                                                                                                            toast.error("Please select payer first.");
                                                                                                            return;
                                                                                                        }
                                                                                                        handleSelectShareBetween(memb?.user?.uuid);
                                                                                                    }}
                                                                                                    checked={watch(
                                                                                                        "s_between"
                                                                                                    )?.includes(memb?.user?.uuid)}
                                                                                                />
                                                                                            </div>
                                                                                        </td>
                                                                                        <td className="expenses-img-wrap">
                                                                                            <img
                                                                                                src={memb?.user?.profile_pic}
                                                                                                alt=""
                                                                                            />
                                                                                        </td>
                                                                                        <td>
                                                                                            {profile?.uuid ===
                                                                                                memb?.user?.uuid
                                                                                                ? `Me`
                                                                                                : memb?.user?.name}
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                            }
                                                                        )
                                                                        : ""}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <ErrorMessage
                                            errors={errors}
                                            name="s_between"
                                            render={({ message }) => (
                                                <p className="valid-error">{message}</p>
                                            )}
                                        />
                                    </div> */}

                            </div>
                            <div className="col-12">
                                <div className="com-input-grp">
                                    <Checkbox
                                        id={"edit_description"}
                                        labelText={"Edit Description"}
                                        checked={editFields.description}
                                        onChange={() => toggleField("description")}
                                    />
                                    {/* <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={editFields.description}
                                        onChange={() => toggleField("description")}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                    <label className="form-label">Edit Description</label> */}
                                    <div className='custom-select'>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder='Type here'
                                            value={watch('description') || ''}
                                            onInput={(e: any) => {
                                                setValue('description', e.target.value);
                                                trigger('description');
                                            }}
                                        />
                                        <ErrorMessage
                                            errors={errors}
                                            name="description"
                                            render={({ message }) => <p className='valid-error'>{message}</p>}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='pb-4 d-flex gap-3'>
                                <button className='custom-grayed-btn modal-light-btn btn-close-modal mt-2' style={{ width: "50%" }} data-bs-dismiss="modal" aria-label="Close" disabled={updateExpense?.loading} type="button" onClick={onCancel}>Cancel</button>
                                <Button className='com-btn mt-2' type="submit" text="submit" style={{ width: "50%" }} loading={updateExpense?.loading}>Save</Button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default EditAllExpences